import React, { useMemo } from "react";
import _ from "lodash";
import { useTranslation } from "react-i18next";

import {
  ButtonDisclosure,
  Dropdown,
  DropdownMenu,
  RadioButton,
} from "@toddle-edu/ds-web";
import classes from "./MealField.scss";
import classNames from "classnames";

const BLANK_ARRAY = [];
export const MealField = ({ field, mealMenus, isPreviewMode, disabled }) => {
  const { t } = useTranslation(["common", "journal"]);

  const menuOptions = useMemo(() => {
    return _.map(mealMenus, menu => {
      return {
        key: _.get(menu, "id"),
        label: _.get(menu, "title"),
      };
    });
  }, [mealMenus]);

  const shouldStopPropagation = e => {
    e?.stopPropagation();
  };

  const foodItemLabelClass = classNames({
    ["text-label"]: true,
  });

  return (
    <div
      className={classes.mealCard}
      data-test-id={`routine-templates-mealfield-container-${field.id}`}
    >
      <div className={classes.mealDropdownContainer}>
        <label
          className="text-label"
          data-test-id={`routine-templates-mealfield-datelabel-${field.id}`}
        >
          {t("journal:date_of_meal")}
        </label>
        <Dropdown
          disabled={disabled}
          testId={`routine-templates-mealfield-date-${_.get(field, "id")}`}
          overlay={
            <DropdownMenu
              options={BLANK_ARRAY}
              shouldStopPropagation={true}
              testId={`routine-templates-mealfield-datemenu-${_.get(
                field,
                "id"
              )}`}
            />
          }
          placement={"bottomRight"}
        >
          <ButtonDisclosure
            onClick={shouldStopPropagation}
            className={classes.dropdownButton}
            variant="neutral"
            type="outlined"
            size="medium"
            isFullWidth={true}
            testId={`routine-templates-mealfield-date-${_.get(field, "id")}`}
          >
            {t("journal:select_an_option")}
          </ButtonDisclosure>
        </Dropdown>
      </div>
      <div className={classes.mealDropdownContainer}>
        <label
          className="text-label"
          data-test-id={`routine-templates-mealfield-menulabel-${_.get(
            field,
            "id"
          )}`}
        >
          {" "}
          {t("journal:choose_a_menu")}
        </label>
        <Dropdown
          disabled={disabled}
          testId={`routine-templates-mealfield-menu-${_.get(field, "id")}`}
          overlay={
            <DropdownMenu
              options={menuOptions}
              shouldStopPropagation={true}
              testId={`routine-templates-mealfield-menuoptions-${_.get(
                field,
                "id"
              )}`}
            />
          }
          placement={"bottomRight"}
        >
          <ButtonDisclosure
            onClick={shouldStopPropagation}
            variant="neutral"
            type="outlined"
            size="medium"
            isFullWidth={true}
            className={classes.dropdownButton}
            testId={`routine-templates-mealfield-menubutton-${_.get(
              field,
              "id"
            )}`}
          >
            {t("journal:select_an_option")}
          </ButtonDisclosure>
        </Dropdown>
      </div>
      {!_.isEmpty(_.get(field, "dataSet.values")) && (
        <div
          className={classes.mealsContainer}
          data-test-id={`routine-templates-mealfield-optionscontainer-${_.get(
            field,
            "id"
          )}`}
        >
          <div key={`meal-options`} className={classes.mealOptionsContainer}>
            <span className={foodItemLabelClass}>{t("journal:food_item")}</span>
            <div className={classes.mealOptions}>
              {_.map(_.get(field, "dataSet.values"), optionItem => {
                if (_.isEmpty(_.get(optionItem, "value")) && isPreviewMode) {
                  return null;
                }
                return (
                  <RadioButton
                    disabled={disabled}
                    key={`option-${_.get(optionItem, "displaySequence")}`}
                    size="medium"
                  >
                    <span className="text-body">
                      {" "}
                      {_.get(optionItem, "value")}
                    </span>
                  </RadioButton>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MealField;
